.spotlight {
  transition:
    top 0.2s,
    right 0.2s,
    bottom 0.2s,
    left 0.2s;
}
